import { render, staticRenderFns } from "./chateau-lagrange.vue?vue&type=template&id=836e066c&scoped=true"
import script from "./chateau-lagrange.vue?vue&type=script&lang=js"
export * from "./chateau-lagrange.vue?vue&type=script&lang=js"
import style0 from "./chateau-lagrange.vue?vue&type=style&index=0&id=836e066c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836e066c",
  null
  
)

export default component.exports